import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getPeriodos } from 'api/recaudacion';

// eslint-disable-next-line react/prop-types
const Periodos = ({ permission }) => (
  <PlainCRUD
    title="Periodos"
    permission={permission}
    get={getPeriodos}
    fields={[defaultFields.descripcion]}
    readOnly
  />
);

export default Periodos;
